export default "__VITE_ASSET__CiSTYv9Q__"